import React from "react";
import {hydrate, render} from "react-dom";
import {Provider} from "react-redux";
import store from "./js/store";
import App from "./components/App";
import "./index.css";

let root_element = document.getElementById("root");
let renderer     = root_element.hasChildNodes() ? hydrate : render;

renderer(
	<Provider store={store}>
		<App/>
	</Provider>,
	root_element
);
